
import { scaleScreen } from "../../components/commons/commons";
import FormLogin from './FormLogin.vue'

export default {
  name: "Login",
  components: {
    FormLogin
  },
  beforeCreate() {
    // this.form = this.$form.createForm(this, { name: "normal_login", onValuesChange: this.onValuesChange });
  },
  created() {
    this.scaleScreen();
    window.addEventListener("resize", this.resize);
  },
  data() {
    return {
      isMobile: false,
      typeBg: 'xl'
    };
  },
  mounted() {
    this.resize()
  },
  methods: {
    scaleScreen,
    resize() {
      const wtd = window.innerWidth;
      const htg = window.innerHeight;
      if (wtd > 1024 && wtd > htg) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
    onHandleChangePassword() {
      this.$router
        .push({
          path: "/change-password",
        })
        .catch((e) => {
          throw e;
        });
    },
  },
};
